import { API } from 'aws-amplify';
import Chat, { Bubble, useMessages } from '@chatui/core';
import '@chatui/core/dist/index.css';
import React, {useState, useEffect} from 'react';
import appLogo from "../images/workgpt_128.png";
import * as Utils from '../utils/Utils.js';
import { createThread, createMessage } from '../graphql/mutations';
import { threadsByUserIdAndLastMessageSentAt, messagesByThreadIdAndCreatedOn } from '../graphql/queries';
// const client = generateClient();

const AskAI = ({isUserSignedIn, isUserSubscribed, loggedInUserId, accessToken, loggedInUserAvatar}) => {
  const { messages, prependMsgs, appendMsg, setTyping } = useMessages([]);
  const [currentThreadId, setCurrentThreadId] = useState('');
  const [viewportHeight, setViewportHeight] = useState(getViewPointHeight());
  function getViewPointHeight() {
    if (window.innerHeight < 550) {
      return (window.innerHeight * 0.70);
    } else if (window.innerHeight < 800) {
      return (window.innerHeight * 0.85);
    } else {
      return (window.innerHeight);
    }
  }
  useEffect(() => {
    syncMessages();

    const handleResize = () => {
      setViewportHeight(getViewPointHeight());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isUserSignedIn, loggedInUserId]);

  const syncMessages = async () => {
    if (isUserSignedIn && loggedInUserId) {
      const result = await API.graphql({ 
        query: threadsByUserIdAndLastMessageSentAt,
        variables: {
          userId: loggedInUserId,
          limit: 20,
          sortDirection: 'DESC'
        }
      });
  
      const threads = result.data.threadsByUserIdAndLastMessageSentAt.items;
      console.log("logged in thread is", threads);
      if (threads?.length > 0 && threads[0].id) {
        setCurrentThreadId(threads[0].id);

        // Todo: might consider get the messages and threads in one query.
        const result = await API.graphql({ 
          query: messagesByThreadIdAndCreatedOn,
          variables: {
            threadId: threads[0].id,
            limit: 100,
            sortDirection: 'ASC'
          }
        });

        const messages = result.data.messagesByThreadIdAndCreatedOn.items;
        console.log("messages list", messages);
        if (messages) {
          prependMsgs(
            messages.map((message, index) => {
              const isMessageFromLoggedInUser = message.senderId == loggedInUserId;
              return {
                _id: message.id,
                type: 'text',
                content: { text: message.content },
                position: isMessageFromLoggedInUser ? 'right' : 'left',
                user: { avatar: isMessageFromLoggedInUser ? loggedInUserAvatar : appLogo }
              };
            })
          );
        }
      }
    }
  }

  async function handleSend(type, val) {
    try {
      console.log('logged in user variables', isUserSignedIn, isUserSubscribed, loggedInUserId, accessToken, loggedInUserAvatar);
      if (type === 'text' && val.trim()) {
        appendMsg({
          type: 'text',
          content: { text: val },
          position: 'right',
          user: { avatar: loggedInUserAvatar },
          createdAt: new Date()
        });

        setTyping(true);

        if (!currentThreadId) {
          // console.log('input variables are', loggedInUserId, { name: Utils.DEFAULT_ASK_AI_TITLE, userId: loggedInUserId, lastMessageSentAt: new Date()});
          const result = await API.graphql({
            query: createThread,
            variables: {
              input: { name: Utils.DEFAULT_ASK_AI_TITLE, userId: loggedInUserId, lastMessageSentAt: new Date()}
            }
          });

          const thread = result.data.createThread;
          setCurrentThreadId(thread.id);
        }

        console.log('currentThreadId', currentThreadId);

        await API.graphql({
          query: createMessage,
          variables: {
            input: { content: val, threadId: currentThreadId, senderId: loggedInUserId }
          }
        });

        const prompt = Utils.getPreSetPromptFromSettings() + " " + val;
        const gptResponse = await Utils.askGPTHttp(accessToken, prompt);

        Utils.setSubscriptionState(gptResponse.subscriptionState);

        if (gptResponse.gptResponse) {
          Utils.increaseDailyRequest();

          if (!Utils.isUserSubscribed(gptResponse.subscriptionState)) {
            const _ = Utils.decrementNumberOfLeftCredits();
          }
        }

        console.log('get gpt response', gptResponse);

        appendMsg({
          type: 'text',
          content: { text: gptResponse.gptResponse },
          user: { avatar: appLogo },
          createdAt: new Date()
        })

        await API.graphql({
          query: createMessage,
          variables: {
            input: { content: gptResponse.gptResponse, threadId: currentThreadId, senderId: Utils.WORKGPT_ID }
          }
        });
        setTyping(false);

        // update lastMessageSentAt date
        // const result = await API.graphql({
        //   query: createThread,
        //   variables: {
        //     input: { name: '', userId: loggedInUserId, lastMessageSentAt: new Date()}
        //   }
        // });

      // setTimeout(() => {
      //   appendMsg({
      //     type: 'text',
      //     content: { text: 'Bala bala' },
      //   });
      // }, 1000);
      }
    } catch (error) {
      console.log("chat message failed: ", error);
      setTyping(false);
      alert("Chat WorkGPT Failed: ", error.message);
    }
  }

  function renderMessageContent(msg) {
    const { content } = msg;
    return <Bubble content={content.text} />;
  }

  return (
    <div style={{fontSize: '16px', '--vh': `${viewportHeight * 0.01}px`}}>
      <style type="text/css">
        {Styles()}
      </style> 
      <Chat
        locale="en-US"
        messages={messages}
        renderMessageContent={renderMessageContent}
        onSend={handleSend}
        placeholder = "Message AI WorkGPT..."
        inputOptions = {{ minRows: 2, maxRows: 4 }}
        // Composer={() => <Input minRows={2} autoSize placeholder="Message AI WorkGPT" onChange={val => setValue3(val)} />}
      />
    </div>
  );
};

const Styles = () => (
  <style>
    {`
      .ChatApp {
        background-color: #F6F8FF;
      }

      .MessageList {
        font-size: 15px;
        width: 100%;
        height: 75vh; /* Fallback for browsers where JavaScript is disabled */
        height: calc(var(--vh, 1vh) * 75); /* Use the custom property */
        overflow-y: scroll;
        padding: 0 10%;
      }

      .Composer-input {
        font-size: 15px;
      }

      .ChatFooter {
        margin-left: 10%;
        margin-right: 10%;
      }

      .Message.right .Bubble {
        background: #1777ff;
        color: white
      }
    `}
  </style>
);

export default AskAI;




/*import { useRef, useState, useEffect, useCallback } from 'react'
import { MessageBox, MessageList, Button, Input, AudioMessage } from 'react-chat-elements'
// import { token } from '../utils/common'
// import {
//   audioMessage,
//   fileMessage,
//   locationMessage,
//   meetingLinkMessage,
//   meetingMessage,
//   photoMessage,
//   spotifyMessage,
//   systemMessage,
//   textMessage,
//   videoMessage,
// } from '../utils/MessageTypes'

let clearRef = () => {}

function useForceUpdate() {
  const [value, setValue] = useState(0)
  return () => setValue(() => value + 1)
}

const AskAI = ({ isUserSignedIn, isUserSubscribed }) => {
  const [messages, setMessages] = useState([])

  useEffect(() => {
    setMessages([
      {
        _id: 1,
        text: 'Hello developer',
        createdAt: new Date(),
        user: {
          _id: 2,
          name: 'React Native',
          avatar: 'https://placeimg.com/140/140/any',
        },
      },
    ])
  }, [isUserSignedIn, isUserSubscribed])

  // const onSend = useCallback((messages = []) => {
  //   setMessages(previousMessages =>
  //     GiftedChat.append(previousMessages, messages),
  //   )
  // }, [])

  const [messageListArray, setMessageListArray] = useState([])
  const [status, setStatus] = useState('')
  const messageListReferance = useRef()
  const inputReferance = useRef()

  const forceUpdate = useForceUpdate()

  const addMessage = () => {
    // let Addmtype: string | number = data || token()
    // switch (data) {
    //   case 0:
    //     Addmtype = 'photo'
    //     setStatus('waiting')
    //     break
    //   case 1:
    //     Addmtype = 'file'
    //     setStatus('sent')
    //     break
    //   case 2:
    //     Addmtype = 'system'
    //     break
    //   case 3:
    //     Addmtype = 'location'
    //     setStatus('received')
    //     break
    //   case 4:
    //     Addmtype = 'spotify'
    //     setStatus('waiting')
    //     break
    //   case 5:
    //     Addmtype = 'meeting'
    //     setStatus('sent')
    //     break
    //   case 6:
    //     Addmtype = 'video'
    //     setStatus('read')
    //     break
    //   case 7:
    //     Addmtype = 'audio'
    //     break
    //   case 8:
    //     Addmtype = 'meetingLink'
    //     break
    //   default:
    //     Addmtype = 'text'
    //     setStatus('read')
    //     break
    //}

    setMessageListArray([...messageListArray])
    clearRef()
    forceUpdate()
  }

  // const randomMessage = (type: string) => {
  //   switch (type) {
  //     case 'photo':
  //       return photoMessage
  //     case 'file':
  //       return fileMessage
  //     case 'system':
  //       return systemMessage
  //     case 'location':
  //       return locationMessage
  //     case 'spotify':
  //       return spotifyMessage
  //     case 'meeting':
  //       return meetingMessage
  //     case 'video':
  //       return videoMessage
  //     case 'audio':
  //       return audioMessage
  //     case 'meetingLink':
  //       return meetingLinkMessage
  //     case 'text':
  //       return textMessage
  //     default:
  //       break
  //   }
  // }

  return (
    <div className="App">
      <div style={{ maxWidth: '300px', margin: '0 auto' }}>
        <MessageBox
          position={'left'}
          type={'text'}
          text={'Hello, this is a message from someone else.'}
        />
        <MessageBox
          position={'right'}
          type={'text'}
          text={'Hi! I am glad to receive your message.'}
          avatar={'https://via.placeholder.com/150'}
        />
      </div>
    </div>
    // <div>
    //   <div style={{ maxWidth: '300px', margin: '0 auto' }}>
    //     <MessageBox
    //       position={'left'}
    //       type={'text'}
    //       text={'Hello, this is a message from someone else.'}
    //     />
    //     <MessageBox
    //       position={'right'}
    //       type={'text'}
    //       text={'Hi! I am glad to receive your message.'}
    //     />
    //     <MessageBox
    //       position={'left'}
    //       type={'photo'}
    //       text={'react.svg'}
    //       data={{
    //         uri: 'https://facebook.github.io/react/img/logo.svg',
    //         status: {
    //           click: false,
    //           loading: 0,
    //         },
    //       }}
    //     />
    //   </div>
    //   <MessageList
    //     className='message-list'
    //     referance={messageListReferance}
    //     dataSource={messageListArray}
    //     lockable={true}
    //     downButton={true}
    //     downButtonBadge={10}
    //     sendMessagePreview={true}
    //   />

    //   <div
    //     style={{
    //       position: 'fixed',
    //       bottom: 0,
    //       right: 0,
    //       left: 0,
    //       margin: '0 auto 1rem auto',
    //       width: '60%',
    //     }}
    //   >
    //     <Input
    //       className='rce-example-input'
    //       placeholder='Write your message here.'
    //       defaultValue=''
    //       multiline={true}
    //       maxlength={300}
    //       onMaxLengthExceed={() => console.log('onMaxLengthExceed')}
    //       referance={inputReferance}
    //       clear={(clear) => (clearRef = clear)}
    //       maxHeight={50}
    //       onKeyPress={(e) => {
    //         if (e.shiftKey && e.charCode === 13) {
    //           return true
    //         }
    //         if (e.charCode === 13) {
    //           clearRef()
    //           addMessage()
    //         }
    //       }}
    //       rightButtons={<Button text='Submit' onClick={() => addMessage()} />}
    //     />
    //   </div>
    // </div>
  )
}

export default AskAI;


// function MessageListExample() {
 
// }

// export default MessageListExample

*/